import React from 'react';

/**
 * ErrorBoundary component to catch and display errors in development
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error info
    console.error('Component Error:', error);
    console.error('Error Info:', errorInfo);
    
    // Store error info for UI display
    this.setState({
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      // Production mode shows minimal info
      if (process.env.NODE_ENV === 'production') {
        return this.props.fallback || <div>Something went wrong. Please try again.</div>;
      }
      
      // Development mode shows detailed error info
      return (
        <div style={{ padding: '20px', fontFamily: 'monospace', whiteSpace: 'pre-wrap', fontSize: '14px' }}>
          <h2 style={{ color: '#E36049' }}>Component Error</h2>
          <div style={{ padding: '10px', backgroundColor: '#f7f7f7', borderRadius: '4px', marginBottom: '10px' }}>
            <strong>{this.state.error && this.state.error.toString()}</strong>
          </div>
          {this.state.errorInfo && (
            <>
              <h3>Component Stack:</h3>
              <div style={{ padding: '10px', backgroundColor: '#f7f7f7', borderRadius: '4px', overflow: 'auto' }}>
                {this.state.errorInfo.componentStack}
              </div>
            </>
          )}
          <button
            onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })}
            style={{ 
              marginTop: '20px', 
              padding: '8px 16px', 
              backgroundColor: '#4A90E2', 
              color: 'white', 
              border: 'none', 
              borderRadius: '4px', 
              cursor: 'pointer'
            }}
          >
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
